import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { RouteComponentProps } from '@reach/router';

import Alert from '@bitcoin-portal/verse-web-components/dist/Alert';
import H1 from '@bitcoin-portal/verse-web-components/dist/H1';
import Link from '@bitcoin-portal/verse-web-components/dist/Link';
import Title from '@bitcoin-portal/verse-web-components/dist/Title';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { InvestmentsList } from './InvestmentsList';
import { AlertWrapper, Header, InvestmentsWrapper } from './styled';

interface Props extends RouteComponentProps {
  setFarm: (farm: IFarmPair) => void;
  onConnectWallet?: (redirect?: string) => void;
  stakedInOldFarm?: boolean;
}

export const Investments: FunctionComponent<Props> = ({
  setFarm,
  onConnectWallet,
  stakedInOldFarm,
}) => {
  return (
    <InvestmentsWrapper>
      <Header>
        <div>
          <H1 className="tab-header">
            <FormattedMessage id="farms.list.title" />
          </H1>
          <Title style={{ color: colors.shade80 }}>
            <FormattedMessage id="farms.list.subtitle" />
          </Title>
        </div>
      </Header>
      <AlertWrapper>
        {stakedInOldFarm ? (
          <Alert design="warning">
            <div>
              <FormattedMessage id="farms.list.oldFarm" />
              <Link
                href="https://etherscan.io/address/0xa51f4C17bb902fF996Ccd766cE072C7CE30E95F4#writeContract#F6"
                newTab
                style={{
                  display: 'block',
                  color: '#d89c55',
                }}
              >
                <FormattedMessage id="farms.list.exitFarm" />
              </Link>
            </div>
          </Alert>
        ) : (
          <Alert design="info">
            <div>
              <FormattedMessage id="farms.list.alert" />
              <Link
                href="https://support.bitcoin.com/en/articles/6959828-verse-farms-faq-page"
                newTab
                style={{ display: 'block' }}
              >
                <FormattedMessage id="farms.global.learn" />
              </Link>
            </div>
          </Alert>
        )}
      </AlertWrapper>
      <InvestmentsList setFarm={setFarm} onConnectWallet={onConnectWallet} />
    </InvestmentsWrapper>
  );
};

export default Investments;
